import { compose, lifecycle } from 'recompose'

import { withRouter } from 'react-router'
import withNotifications from 'components/shared/notifications'

import TeamsMangementSettings from './component'

export default compose(
  withRouter,
  withNotifications,
  lifecycle({
    componentDidMount() {
      const { location, notifications, router } = this.props
      if (location.search.includes('delete=success')) {
        notifications.success(`The team ${location.query.name} was successfully deleted.`)
        router.replace('/settings/teams')
      }
    },
  })
)(TeamsMangementSettings)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Teams/index.js